import { AxiosError } from "axios";
import { publicNexusApi } from "./nexus-api";

export type InviteVerification = {
  ecommerceId: string;
  orderId: string;
  orderNumber: string;
  items: InviteReviewItem[];
  email: string;
  expiresAt: string;
};

export type SubmitReviewPayload = {
  reviews: SubmitReviewItem[];
};

export type SubmitReviewResponse = {
  ok: boolean;
  reviewIds: string[];
};

export type SubmitReviewItem = {
  productId: string;
  rating: number;
  content?: string;
};

export type InviteReviewItem = {
  productId: string;
  productName?: string | null;
  productSlug?: string | null;
  productImage?: string | null;
  variantName?: string | null;
  options?: string[];
  addons?: Array<
    | string
    | {
        name?: string;
        price?: number | null;
      }
  >;
};

export type ProductReviewItem = {
  id: string;
  productId: string;
  productName?: string | null;
  productSlug?: string | null;
  productImage?: string | null;
  variantName?: string | null;
  rating: number;
  authorName?: string | null;
  title?: string | null;
  content?: string | null;
  createdAt: string;
};

export type ProductReviewsResponse = {
  items: ProductReviewItem[];
  total: number;
  page: number;
  limit: number;
};

export type ProductReviewSort = "newest" | "oldest" | "highest" | "lowest";

export type ProductReviewsParams = {
  productId: string;
  page?: number;
  limit?: number;
  sort?: ProductReviewSort;
};

export type ProductReviewStats = {
  averageRating: number;
  total: number;
  breakdown?: Record<1 | 2 | 3 | 4 | 5, number>;
};

export async function fetchReviewInvite(token: string) {
  const { data } = await publicNexusApi.get<InviteVerification>("/public/reviews/invite", {
    params: { token },
  });
  return data;
}

export async function submitReview(token: string, payload: SubmitReviewPayload) {
  const { data } = await publicNexusApi.post<SubmitReviewResponse>("/public/reviews", {
    token,
    ...payload,
  });
  return data;
}

export async function fetchProductReviews(params: ProductReviewsParams) {
  const { data } = await publicNexusApi.get<ProductReviewsResponse>(
    `/public/reviews/product/${encodeURIComponent(params.productId)}`,
    {
      params: {
        page: params.page ?? 1,
        limit: params.limit ?? 5,
        sort: params.sort ?? "newest",
      },
    },
  );
  return data;
}

export function getReviewsErrorMessage(error: unknown): string {
  const axiosError = error as AxiosError<{ message?: string | string[] }>;
  const message = axiosError?.response?.data?.message;

  if (Array.isArray(message)) {
    return message[0] ?? "Wystąpił błąd.";
  }

  if (typeof message === "string") {
    return message;
  }

  return "Wystąpił błąd.";
}
